import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { ColorEnum } from 'app/utils/mapColors'
import { gql } from 'graphql-request'

import { GenericBlock } from './generic'

export const promoBanner = gql`
  fragment promoBanner on PromoBanner {
    backgroundColour
    foregroundColour
    text
    ctaLabel
    ctaLink
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface PromoBanner extends GenericBlock<'PromoBanner'> {
  backgroundColour?: ColorEnum
  foregroundColour?: ColorEnum
  text: any[]
  ctaLabel?: string
  ctaLink?: string
  excludedPlatforms: ExcludedPlatforms
}

